'use client';

import React__default, { useContext, useMemo } from 'react';
import { OverflowWrapper } from '../../InputContainer.css.js';
import { CascaderContext } from '../../../../context/reducer.js';
import { getSelectedSingleChildrenName, getSelectedParentName } from '../../../../helper.js';
import ParentItem from '../ParentItem/index.js';
import { ELanguage } from '../../../../../Utils/constants.js';

var OverflowItems = function () {
    var _a = useContext(CascaderContext), props = _a.props, state = _a.state;
    var options = props.options, selectOptions = props.selectOptions, langCode = props.langCode;
    var isShow = state.isShow, temporaryValue = state.temporaryValue, value = state.value;
    return useMemo(function () {
        var displayValue = isShow ? temporaryValue : value;
        var selectedParentName = null;
        var selectedChildren = null;
        if (selectOptions.isSingleSelect) {
            selectedChildren = getSelectedSingleChildrenName(displayValue, options.children);
        }
        else {
            selectedParentName = getSelectedParentName(displayValue, options.parent);
        }
        return (React__default.createElement(OverflowWrapper, null, selectOptions.isSingleSelect ? (React__default.createElement(React__default.Fragment, null, selectedChildren !== null && (React__default.createElement(ParentItem, { label: langCode === ELanguage.EN ? selectedChildren.nameEn : selectedChildren.name, id: selectedChildren.id, isHaveRemoveIcon: false })))) : (React__default.createElement(React__default.Fragment, null,
            selectedParentName !== null && selectedParentName.length > 0 && (React__default.createElement(ParentItem, { label: selectedParentName[0].name, id: selectedParentName[0].id, isHaveRemoveIcon: true })),
            selectedParentName !== null && selectedParentName.length > 1 && (React__default.createElement(ParentItem, { label: "+".concat(selectedParentName.length - 1), id: -1 }))))));
    }, [isShow, options.parent, options.children, temporaryValue, value, langCode]);
};

export { OverflowItems as default };
//# sourceMappingURL=index.js.map
